import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "app-footer-link",
      to: "/termos"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("Termo de Uso", -1)
      ]))]),
      _: 1
    }),
    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "app-footer-sep" }, "·", -1)),
    _createVNode(_component_router_link, {
      class: "app-footer-link",
      to: "/privacidade"
    }, {
      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createTextVNode("Política de Privacidade", -1)
      ]))]),
      _: 1
    })
  ]))
}